import { useEffect, useState } from 'react';
import { theme } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useNavigate } from 'react-router-dom';
import SignUpService from 'services/signup';
import { useApp } from 'contexts/app';

const signUpService = new SignUpService();

const useCreateShop = () => {
  const { token } = theme.useToken();
  const [form] = useForm();
  const [otpForm] = useForm();
  const { showLoading } = useApp();
  const navigate = useNavigate();

  const [idOtp, setIdOtp] = useState();
  const [isShowOtp, setIshowOpt] = useState(false);

  useEffect(() => {
    form.setFieldsValue({
      phone: '',
      agree: true,
      shop: {
        title: '',
        image: {
          url: 'https://storage.googleapis.com/cubebio/data/ed50ce4f-5451-44f7-a059-750b67ee9ace.png',
          sm_url: 'https://storage.googleapis.com/cubebio/data/sm_ed50ce4f-5451-44f7-a059-750b67ee9ace_1751080357909.png',
          md_url: 'https://storage.googleapis.com/cubebio/data/md_ed50ce4f-5451-44f7-a059-750b67ee9ace_1751080357909.png',
          lg_url: 'https://storage.googleapis.com/cubebio/data/lg_ed50ce4f-5451-44f7-a059-750b67ee9ace_1751080357909.png',
        },
        description: '',
      },
    });
  }, [form]);

  const handleCreate = () => {
    form.submit();
  };

  const onFinish = async () => {
    const data = { ...form.getFieldsValue() };
    showLoading(true);
    const { otp } = await signUpService.createShop(data);
    setIdOtp(otp.id);
    showLoading(false);
    setIshowOpt(true);
  };

  const onOtpFinish = async () => {
    const data = { ...otpForm.getFieldsValue() };
    setIshowOpt(false);
    showLoading(true);
    try {
      const createdUser = await signUpService.createShopWithOTP({ id: idOtp, otp: data.otp });
      if (createdUser) {
        navigate(`/thank-you?shop_url=${createdUser.shop_url}`);
      }
    } catch (error) {
      alert(error.message);
    }
    showLoading(false);
  };

  const phoneValidator = async (_, value) => {
    return new Promise(async (resolve, reject) => {
      if (!value || value.length < 10) {
        resolve();
        return;
      }

      try {
        const data = await signUpService.checkPhone(value);
        if (data.error) {
          reject(new Error('Số điện thoại này đã được đăng ký rồi. Bạn hãy dùng số điện thoại này để đăng nhập nhé'));
          return;
        }
        resolve();
      } catch (error) {
        reject(new Error('Không thể kiểm tra số điện thoại'));
      }
    });
  };

  return {
    token,
    form,
    otpForm,
    navigate,
    isShowOtp,
    setIshowOpt,
    handleCreate,
    onFinish,
    onOtpFinish,
    phoneValidator,
  };
};

export default useCreateShop;
